import React from 'react'

import IISc from './images/IISc_Master_Seal_Black.jpg'


const Internaational = () => {
  return (
    <>
  
    <div>
         <div className='ntnl-head'>NATIONAL COLLABORATION</div>
            <div className='national'>
              <div className="national-images"><img src="https://upload.wikimedia.org/wikipedia/en/thumb/6/69/IIT_Madras_Logo.svg/1200px-IIT_Madras_Logo.svg.png" alt="" />IIT Madras</div>
              <div className="national-images">  <img src="https://upload.wikimedia.org/wikipedia/en/thumb/8/82/Indian_Institute_of_Technology_Bhubaneswar_Logo.svg/800px-Indian_Institute_of_Technology_Bhubaneswar_Logo.svg.png" alt="" />IIT Bhubaneshwar</div>
              <div className="national-images"> <img src="https://upload.wikimedia.org/wikipedia/en/thumb/1/1d/Indian_Institute_of_Technology_Bombay_Logo.svg/1200px-Indian_Institute_of_Technology_Bombay_Logo.svg.png" alt="" />IIT Bombay</div>
              <div className="national-images"><img src="https://upload.wikimedia.org/wikipedia/en/thumb/e/ea/Indian_Institute_of_Technology_Dharwad_Logo.svg/1200px-Indian_Institute_of_Technology_Dharwad_Logo.svg.png" alt="" />IIT Dharwad</div>
              <div className="national-images"> <img src="https://upload.wikimedia.org/wikipedia/en/thumb/a/a3/IIT_Kanpur_Logo.svg/1200px-IIT_Kanpur_Logo.svg.png" alt="" />IIT Kanpur</div>
              <div className="national-images"> <img src="https://upload.wikimedia.org/wikipedia/en/4/4c/Official_Logo_of_IIT%28BHU%29%2CVaranasi%2CIndia%2C2013.png" alt="" />IIT Varanasi</div>
              <div className="national-images"><img src={IISc} alt="" />IISc Banglore</div>
              <div className="national-images"><img src="https://upload.wikimedia.org/wikipedia/en/thumb/e/e3/Raja_Ramanna_Centre_for_Advanced_Technology.svg/1200px-Raja_Ramanna_Centre_for_Advanced_Technology.svg.png" alt="" />Raja Ramanna Centre For Advanced Technology</div>
              <div className="national-images"><img src="https://upload.wikimedia.org/wikipedia/en/0/05/Institute_of_Nano_Science_and_Technology_%28INST%29%2C_Mohali_Logo.png" alt="" />Institute Of Nano Science and Technology</div>
              <div className="national-images"><img src="https://img.studyclap.com/img/institute/logo/c58f655882-mnnit-prayagraj.png" alt="" />MNNIT Prayagraj</div>
              <div className="national-images"><img src="https://pbs.twimg.com/profile_images/1293853426992836609/9lghxDgH_400x400.jpg" alt="" />CIAE Bhopal</div>
              <div className="national-images"><img src="https://upload.wikimedia.org/wikipedia/en/9/97/Kameshwar_Singh_Darbhanga_Sanskrit_University_logo.png" alt="" />Kameshwar Singh Darbhanga Sanskrit University</div>
               
               
               
                
                
               
               
                
                
                
                
                
                

            </div>
            <div className='intrntnl-head'>INTERNATIONAL COLLABORATION</div>
            <div className="international">
                <img src="https://communications.oregonstate.edu/sites/communications.oregonstate.edu/files/screen_shot_2017-04-21_at_4.23.07_pm.png" alt="" />
                <img src="https://www.qschina.cn/sites/default/files/profiles/logos/polish-academy-of-sciences_592560df9988f300e2320892_large.jpg" alt="" />
                <img src="https://www.cam.ac.uk/sites/www.cam.ac.uk/files/inner-images/logo.jpg" alt="" />
                <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/f/f7/Purdue_University_system_logo.svg/2560px-Purdue_University_system_logo.svg.png" alt="" />
                <img src="https://upload.wikimedia.org/wikipedia/commons/6/62/UnimeLogo.gif" alt="" />
                <img src="https://upload.wikimedia.org/wikipedia/en/6/60/National_Dong_Hwa_University_logo.svg" alt="" />
                <img src="https://upload.wikimedia.org/wikipedia/commons/8/8e/Chonnam_National_University_sygnature.jpg" alt="" />
                <img src="https://oisp.hcmut.edu.vn/en/wp-content/uploads/2022/11/logo_nagaokaut.jpg" alt="" />
                <img src="https://upload.wikimedia.org/wikipedia/commons/8/8e/KUL.svg" alt="" />
                <img src="https://i1.rgstatic.net/ii/institution.image/AS%3A267458353532930%401440778448163_l" alt="" />
                <img src="https://res.cloudinary.com/crunchbase-production/image/upload/c_lpad,h_170,w_170,f_auto,b_white,q_auto:eco,dpr_1/fkngzqe35yt9krqcfr7m" alt="" />
                <img src="https://www.a-star.edu.sg/images/librariesprovider16/default-album/astar_imre_horizontal-logo_rgb.png?sfvrsn=6400942a_4" alt="" />
                <img src="https://www.triplehelixassociation.org/wp-content/uploads/2016/03/tsu.jpg" alt="" />
                <img src="https://upload.wikimedia.org/wikipedia/en/thumb/c/c3/Incheon_National_University.svg/1200px-Incheon_National_University.svg.png" alt="" />
                <img src="https://www.earto.eu/wp-content/uploads/AIST.jpg" alt="" />
                <img src="https://seeklogo.com/images/U/university-of-stuttgart-logo-2DAFB15D2F-seeklogo.com.png" alt="" />
                <img src="https://www.imt-atlantique.fr/sites/default/files/ecole/IMT_Atlantique_logo.png" alt="" />

            </div>
      
    </div>
   
    </>
  )
}

export default Internaational
